import uniq from 'lodash/uniq';
import omit from 'lodash/omit';
import {
  SET_CONVERSATION_RATING_SCORE,
  SET_CONVERSATION_RATING_SCORE_DATA,
  DELETE_CONVERSATION_RATING,
} from 'actions/types';
import {
  INITIAL_CONVERSATION_RATINGS_STATE,
  INITIAL_RATING_SCORE_DATA,
} from 'constants/conversationRatingInitialState';

const conversationRatings = (state = INITIAL_CONVERSATION_RATINGS_STATE, action) => {
  switch (action.type) {
    case SET_CONVERSATION_RATING_SCORE: {
      const { conversationId, ratingScore } = action.payload;
      const allConversationRatings = uniq([...state.allConversationRatings, conversationId]);

      return {
        ...state,
        allConversationRatings,
        [conversationId]: {
          ...state[conversationId],
          ratingScore,
        },
      };
    }

    case SET_CONVERSATION_RATING_SCORE_DATA: {
      const { conversationId, ratingScore, ratingScoreData } = action.payload;
      const previouslyScoreData = { ...INITIAL_RATING_SCORE_DATA, ...state[conversationId][ratingScore] };
      const { ratingScoreDetails, currentlyActiveNode, selectedExpert } = ratingScoreData;

      return {
        ...state,
        [conversationId]: {
          ...state[conversationId],
          [ratingScore]: {
            ratingScoreDetails: ratingScoreDetails || previouslyScoreData.ratingScoreDetails,
            currentlyActiveNode: Number.isInteger(currentlyActiveNode)
              ? currentlyActiveNode
              : previouslyScoreData.currentlyActiveNode,
            selectedExpert: selectedExpert || previouslyScoreData.selectedExpert,
          },
        },
      };
    }

    case DELETE_CONVERSATION_RATING: {
      const { conversationId } = action.payload;
      const allConversationRatings = state.allConversationRatings.filter((id) => id !== conversationId);
      const newState = omit(state, [conversationId, 'allConversationRatings']);
      newState.allConversationRatings = allConversationRatings;

      return newState;
    }

    default:
      return state;
  }
};

export default conversationRatings;
